import FormErrors from "@/components/FormErrors/FormErrors";
import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation";
import uuidv4 from "uuid/v4";
import { JSConn } from "@/utilities/js-conn";

export default {
  name: "commodityEditForm",
  components: {
    FormErrors,
    LoadingAnimation,
  },
  props: {
    commodityId: String,
  },
  data() {
    return {
      dataLoaded: false,
      loadingMessage: "Loading Commodity...",
      hasFormErrors: false,
      cancelParams: { name: "commodities" },
      formErrors: [],
      commodity: {
        name: null,
        description: null,
      },
    };
  },
  created() {
    if (this.commodityId === "new") {
      this.commodity = {
        id: uuidv4(),
        name: "New",
        description: "",
        color: "hsla(276, 66%, 65%, 1)",
      };
      this.dataLoaded = true;
      this.$nextTick(() => this.$refs.firstInput.select());
    } else {
      const jsConn = new JSConn();

      jsConn.formParams = {
        id: this.commodityId,
      };

      this.$store.dispatch("needCommodity", jsConn).then(() => {
        // correct commodity is in the store
        this.commodity = {
          name: this.apiCommodity.name,
          description: this.apiCommodity.description,
          id: this.apiCommodity.id,
          color: this.apiCommodity.color,
        };
        this.dataLoaded = true;
        this.cancelParams = {
          name: "commodities",
        };
        this.$nextTick(() => this.$refs.firstInput.select());
      });
    }
  },
  methods: {
    submitForm(evt) {
      evt.preventDefault();
      const jsConn = new JSConn();
      jsConn.formParams = this.commodity;
      jsConn.toRoutePath = "/commodities";

      let storeDispatch;

      if (this.commodityId === "new") {
        storeDispatch = "createCommodity";
      } else {
        storeDispatch = "updateCommodity";
      }

      this.$store
        .dispatch(storeDispatch, jsConn)
        .then(jsConn => {
          this.$router.push(jsConn.toRoutePath);
          return Promise.resolve(jsConn);
        })
        .catch(jsConn => {
          this.hasFormErrors = true;
          this.formErrors = jsConn.error["response"]["data"];
        });
    },
    showDeleteModal() {
      this.$refs["deleteModal"].show();
    },
    hideDeleteModal() {
      this.$refs["deleteModal"].hide();
    },
    deleteCommodity() {
      const jsConn = new JSConn();
      jsConn.toRoutePath = "/commodities";
      jsConn.formParams = {
        id: this.commodityId,
      };
      this.$store.dispatch("deleteCommodity", jsConn).then(jsConn => {
        this.$router.push(jsConn.toRoutePath);
        return Promise.resolve(jsConn);
      });
    },
  },
  computed: {
    apiCommodity: function() {
      return this.$store.getters.commodity;
    },
  },
};
